import React, { Fragment, memo } from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';

import RowActions from 'components/RowActions';
import { rowActions as TEXT } from 'locales/en/payout';
import { exportPayoutTransactions } from 'redux/slices/payout';

const PayoutActions = ({
  isOpen,
  onClickOpen,
  onClose,
  payoutId,
  position,
}) => {
  const dispatch = useDispatch();
  const renderItems = () => {
    const onExport = () => {
      onClose();
      return dispatch(exportPayoutTransactions(payoutId));
    };

    const className =
      'block w-full text-left bg-white py-2 px-5 text-xs text-javelin-gray-dark hover:bg-javelin-babyBlue cursor-pointer';
    const viewItem = (
      <Link to={`/payouts/${payoutId}`} className={className}>
        {TEXT.view}
      </Link>
    );
    const exportButton = (
      <button onClick={onExport} className={className}>
        {TEXT.export}
      </button>
    );

    let options = [viewItem, exportButton];

    return options.map((item, idx) => <Fragment key={idx}>{item}</Fragment>);
  };

  return (
    <RowActions
      onClickOpen={onClickOpen}
      isOpen={isOpen}
      onClose={onClose}
      position={position}
    >
      {renderItems()}
    </RowActions>
  );
};

PayoutActions.propTypes = {
  onClickOpen: PropTypes.func,
  onClose: PropTypes.func,
  isOpen: PropTypes.bool,
  position: PropTypes.oneOf(['top', 'bottom']),
  payoutId: PropTypes.number,
};
PayoutActions.defaultProps = {
  position: 'bottom',
};

export default memo(PayoutActions);
